<template>
  <div id="app">
    <notify-component></notify-component>
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-corporate.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>
import { mapState, mapActions } from 'vuex'
import NotifyComponent from '@/components/common/NotifyComponent'

export default {
  components: {
    NotifyComponent
  },
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: '%s - ExpoDogs Admin'
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  }
}
</script>
